<div
  class="sui-time-picker"
  [class.sui-time-picker--disabled]="isDisabled()"
  role="group"
  aria-label="Time"
>
  <!-- Hour -->
  <div class="sui-time-picker__col" (wheel)="onWheel('hour', $event)">
    <button
      type="button"
      class="sui-time-picker__step"
      tabindex="-1"
      aria-label="Increment hours"
      [disabled]="isDisabled()"
      (click)="step('hour', 1)"
    >
      <fa-icon [icon]="faUp" />
    </button>
    <label class="sui-time-picker__sr-only" [for]="effectiveId + '-h'"
      >Hours</label
    >
    <sui-input
      class="sui-time-picker__seg"
      [id]="effectiveId + '-h'"
      [disabled]="isDisabled()"
      placeholder="--"
      [ngModel]="hourText()"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onInput('hour', $event)"
      (keydown.arrowUp)="$event.preventDefault(); step('hour', 1)"
      (keydown.arrowDown)="$event.preventDefault(); step('hour', -1)"
      (focusin)="onFocus('hour')"
      (focusout)="onBlur('hour')"
    />
    <button
      type="button"
      class="sui-time-picker__step"
      tabindex="-1"
      aria-label="Decrement hours"
      [disabled]="isDisabled()"
      (click)="step('hour', -1)"
    >
      <fa-icon [icon]="faDown" />
    </button>
  </div>

  <span class="sui-time-picker__sep" aria-hidden="true">:</span>

  <!-- Minute -->
  <div class="sui-time-picker__col" (wheel)="onWheel('minute', $event)">
    <button
      type="button"
      class="sui-time-picker__step"
      tabindex="-1"
      aria-label="Increment minutes"
      [disabled]="isDisabled()"
      (click)="step('minute', 1)"
    >
      <fa-icon [icon]="faUp" />
    </button>
    <label class="sui-time-picker__sr-only" [for]="effectiveId + '-m'"
      >Minutes</label
    >
    <sui-input
      class="sui-time-picker__seg"
      [id]="effectiveId + '-m'"
      [disabled]="isDisabled()"
      placeholder="--"
      [ngModel]="minuteText()"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onInput('minute', $event)"
      (keydown.arrowUp)="$event.preventDefault(); step('minute', 1)"
      (keydown.arrowDown)="$event.preventDefault(); step('minute', -1)"
      (focusin)="onFocus('minute')"
      (focusout)="onBlur('minute')"
    />
    <button
      type="button"
      class="sui-time-picker__step"
      tabindex="-1"
      aria-label="Decrement minutes"
      [disabled]="isDisabled()"
      (click)="step('minute', -1)"
    >
      <fa-icon [icon]="faDown" />
    </button>
  </div>

  @if (seconds) {
    <span class="sui-time-picker__sep" aria-hidden="true">:</span>

    <!-- Second -->
    <div class="sui-time-picker__col" (wheel)="onWheel('second', $event)">
      <button
        type="button"
        class="sui-time-picker__step"
        tabindex="-1"
        aria-label="Increment seconds"
        [disabled]="isDisabled()"
        (click)="step('second', 1)"
      >
        <fa-icon [icon]="faUp" />
      </button>
      <label class="sui-time-picker__sr-only" [for]="effectiveId + '-s'"
        >Seconds</label
      >
      <sui-input
        class="sui-time-picker__seg"
        [id]="effectiveId + '-s'"
        [disabled]="isDisabled()"
        placeholder="--"
        [ngModel]="secondText()"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onInput('second', $event)"
        (keydown.arrowUp)="$event.preventDefault(); step('second', 1)"
        (keydown.arrowDown)="$event.preventDefault(); step('second', -1)"
        (focusin)="onFocus('second')"
        (focusout)="onBlur('second')"
      />
      <button
        type="button"
        class="sui-time-picker__step"
        tabindex="-1"
        aria-label="Decrement seconds"
        [disabled]="isDisabled()"
        (click)="step('second', -1)"
      >
        <fa-icon [icon]="faDown" />
      </button>
    </div>
  }

  @if (meridian) {
    <button
      type="button"
      class="sui-time-picker__meridian"
      [attr.aria-label]="'Toggle AM/PM (currently ' + meridianValue() + ')'"
      [disabled]="isDisabled()"
      (click)="toggleMeridian()"
    >
      {{ meridianValue() }}
    </button>
  }
</div>
